export default __webpack_public_path__ + "static/image-BUIE-portal-aed5730d44514d0c088f3db6a9d315cd.png";